import { html, nothing } from '@shared/utils/rendering/html';

import { useMemo } from 'preact/hooks';

import Table from '@shared/components/tables';

import {
    SystemsColumns,
    SystemsFilters,
} from '@core/configs/admin/systems/table/systems-table.config';
import SystemsTableActions from './systems-table.actions';

import { useSystemData } from './hooks/use-system-data';
import { useSystemFilters } from './hooks/use-system-filters';

export default function SystemsTable() {
    const { requestParams, tableFilters } = useSystemFilters();
    const { tableData } = useSystemData(requestParams);

    const config = useMemo(() => {
        return {
            columns: SystemsColumns,
            filters: tableFilters,
            actions: SystemsTableActions,
        };
    }, [tableFilters]);

    return config
        ? html` <div class="card"><${Table} config=${config} data=${tableData} /></div>`
        : nothing;
}
